/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react'
import './CampaignTypeStyle.css'
import useCampaignType from './useCampaignType'
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import ChartComponent from '@components/common/Chart/ChartComponent.component'
import { marketingOverviewFilter } from '@dataTypes/marketing.type'

interface CampaignTypeProps {
  overviewDateFilter: marketingOverviewFilter
}

const CampaignType: React.FC<CampaignTypeProps> = ({ overviewDateFilter }) => {
  const hooks = useCampaignType(overviewDateFilter)

  const tooltipTemplate = useCallback((args: any): JSX.Element => {
    return (
      <div className="mmc-custom-tooltip">
        <div className="tooltip-date">{args.x}</div>
        <div className="tooltip-series" style={{ color: args.color }}>
          <span>
            <span
              className="tooltip-series-marker"
              style={{
                backgroundColor: args.series.interior,
              }}
            />
            {args.series.properties.name}
          </span>
          <span>{args.y}</span>
        </div>
      </div>
    )
  }, [])

  return (
    <div className="mo-a-campaign-type mo-board">
      <div className="mo-a-mo-header">
        <div className="mo-a-mo-header-left">
          <span className="mo-secondary-header">Campaign type</span>
          <DropDownListComponent
            dataSource={hooks.campaignDropdownOptions}
            placeholder="Select campaign"
            value={hooks.selectedCampaign}
            change={(e) => hooks.setSelectedCampaign(e.value)}
          />
        </div>
      </div>
      <ChartComponent
        id="campaign-type-stacked-bar"
        cornerRadius={{
          topLeft: 4,
          topRight: 4,
          bottomLeft: 4,
          bottomRight: 4,
        }}
        data={hooks.data}
        height="290px"
        columnWidth={0.25}
        tooltipTemplate={tooltipTemplate}
        type="StackingColumn"
        xName="x"
        yName={[
          'Post-tx',
          'Follow-up',
          'Pat. edu',
          'Celebration',
          'Reminder',
          'Recall',
          'Promotion',
        ]}
        yColor={[
          '#44761E',
          '#A4CC6B',
          '#163DA2',
          '#65ACF5',
          '#9DD8AC',
          '#24A1A3',
          '#185DD8',
        ]}
      />
    </div>
  )
}

export default CampaignType
